import { CHECK_REALTIME_SOCKET_CONNECTION } from 'actions/Types';

function CheckRealtimeSocketConnection() {
  return (dispatch, _, socket) => {
    const action = {
      type: CHECK_REALTIME_SOCKET_CONNECTION,
      payload: socket?._socket?.connected
    };
    dispatch(action);
  };
}

export default CheckRealtimeSocketConnection;
